import { render } from "./PWAPrompt.vue?vue&type=template&id=a15399d6&scoped=true"
import script from "./PWAPrompt.vue?vue&type=script&lang=js"
export * from "./PWAPrompt.vue?vue&type=script&lang=js"

import "./PWAPrompt.vue?vue&type=style&index=0&id=a15399d6&lang=scss&scoped=true"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15399d6"]])

export default __exports__